"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (selectedPaths) => {
    return selectedPaths.map(({ propertyPath, selectedPath }) => {
        // Merge paths to get the full selected path.
        const fullPath = [...propertyPath, ...selectedPath];
        // In RaydiantKit we only want to know about selected paths changes
        // from applicationVariables, and applicationVariables is called values.
        // remove 'applicationVariables' from the start of the path to avoid confusion.
        if (fullPath[0] === 'applicationVariables')
            fullPath.shift();
        return fullPath;
    });
};
//# sourceMappingURL=mapSelectedPathsToProps.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/mapSelectedPathsToProps.js